import React, { useState } from 'react';

interface PasswordProtectionProps {
  onAuthenticate: () => void;
}

const PasswordProtection: React.FC<PasswordProtectionProps> = ({ onAuthenticate }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const correctPassword = process.env.REACT_APP_WEDDING_PASSWORD;
    if (password === correctPassword) {
      onAuthenticate();
    } else {
      setError('Incorrect password. Please try again.');
    }
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center px-4">
      {/* Background Image - Desktop */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat hidden sm:block"
        style={{
          backgroundImage: `url('/images/password-protection/3D2A7738_pwd.jpg')`,
          filter: 'grayscale(100%) contrast(1.1)'
        }}
      />
      
      {/* Background Image - Mobile */}
      <div 
        className="absolute inset-0 bg-cover bg-no-repeat block sm:hidden"
        style={{
          backgroundImage: `url('/images/password-protection/3D2A7738_optimized.jpg')`,
          backgroundPosition: 'right top',
          filter: 'grayscale(100%) contrast(1.1)'
        }}
      />
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-30" />
      
      {/* Content */}
      <div className="relative z-10 bg-white bg-opacity-30 backdrop-blur-sm p-8 max-w-sm w-full border border-white border-opacity-30">
        <div className="text-center mb-6">
          <h1 className="font-display text-white mb-3 tracking-wide text-3xl">
            Shivangi / Ishan
          </h1>
          <p className="text-white text-sm">
            Welcome to our wedding.
          </p>
        </div>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="password" className="block text-xs font-medium text-white mb-2 uppercase tracking-wider">
              Enter Password
            </label>
            <div className="relative">
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-white bg-opacity-60 border-0 border-b border-white border-opacity-70 rounded-none px-0 py-2 pr-8 focus:outline-none focus:border-white transition-all duration-300 text-sm text-soft-black placeholder-soft-black placeholder-opacity-60"
                placeholder="Password"
                required
              />
              <button
                type="submit"
                className="absolute right-2 top-1/2 -translate-y-1/2 text-white hover:text-gray-200 transition-colors duration-300"
                aria-label="Submit password"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </button>
            </div>
          </div>
          
          {error && (
            <div className="bg-red-100 bg-opacity-80 border border-red-300 text-red-700 px-3 py-2 text-xs">
              {error}
            </div>
          )}
        </form>

      </div>
    </div>
  );
};

export default PasswordProtection;